export default "__VITE_ASSET__CwZJwekG__";